export const League = {
  employer:'League',
  title: 'Web Development Intern',
  bullets:["Worked with the health journey team to create day to day activities that improved the health of millions of users.",

    "Work with my peers to implement REST api into the league system",
    
    "Took part in frequent code reviews for colleagues",
    
    "Created reusable and testable components using league’s design system",
    
    "Helped execute a company wide dev initiative to allow other teams to easily update customized assets",
    
    "Maintained a high test coverage percentage with react testing library and jest",
    
    "Followed Agile methodology processes throughout the internship",
    
    "Took part in User Acceptance Testing of features that were worked on by the Journey Team",
    
    "Updated teams Storybook files with the new and updated csf format, that improved overall developer storybook interactions.",
    
    "Added data analytics to features worked on throughout the term",
    
    "Enabled/empowered the data team by increasing analytics coverage for features worked on throughout the term",
    
    "Implemented features with attention to accessibility and user experience",
    
    "Exercised soft skills by frequently presenting new features to technical and non-technical people",
    
    "Followed detailed technical docs with efficiency",
    
    "Came up with ways to reuse components more efficiently",
    
    "Provided options for implementing components and was able to discern the correct approach"]
}

export const Juno = {
  employer:'Juno College of Technology',
  title: 'Administrative coordinator',
  bullets:["Lead Tech-Talk preparation guiding students in best practices for stand-up presentation",

  "Detail oriented data entry: transcript, grades, expense reports",
  
  "Manage and set up Slack channels and Github invitations",
  
  "Salesforce initiation of program folders and population of tracked content including formula for expected/current sales",
  
  "Develop master docs for student tracking, course work, and grade tracking and link to master tracking using google sheets",
  
  "Create full course packages including InDesign schedule, and digital distribution",
  ]
}

export const DX = {
  employer:'Design Exchange',
  title: 'Education Coordinator',
  bullets:[
    "Speaker and educator for sustainable and accessible design principles",
    "Public speaking commitments and award presentation for the Government of Ontario's Accessible Design Competition",
    "Key note speaker and promoter on behalf of the Design Exchange programming team",
    "Program Developer for camps and in-house design workshops",
    "Delivered an increase in attendance through activity development and project management in the Home School Program",
    "Website maintenance for the Expo Design Innovation and Technology (EDIT 2017)",
    "Content creation for tours, workshops and public program"
  ]

}

export const MFTU = {
  employer: 'Message from the Universe',
  title: 'one card' ,
  bullets: [
    "Miss Universe is calling you about your best timeline, will you receive her message after the tone?",
    "Simple, quick, and sure to start a conversation!",
    "Bring a friend, nothing embarrassing or personal here, just a reminder why you make the cosmos happy.",
  ]
}
export const Probing = {
  employer: 'Best Timeline Insurance Policy',
  title: 'three cards',
  bullets: [
    "Tell me what you want, what you Really Really want, and we’ll figure out how to get you there Guaranteed!",
    "Spicy, honest, bold flavours perfect for tasty sit-down snack!",
    "Bring a friend at your own discretion. More verbose than a quick message and you will get homework.",
  ]
}
export const Private = {
  employer: 'LOL (Love Of ur Life)',
  title: 'seven cards',
  bullets: [
    "7 card spread helping you find your love",
    "Heavy, full bodied, crying allowed",
    "No friends, bring your honest heart",
  ]
}
export const Book = {
  employer: 'Invite a Crashlanding',
  title: 'book now ',
  bullets: [
    "Invite me to crashland your bar, cluhb, bookshop, eatery, theatre, market or festival",
    "Age appropriate (16+) and extra shiny and flourecent",
    "Every one who wants to interact with the Alien is welcome to say howdy, take photos for the 'gram' and or dance with me",
    "Readings available to the interested humans at prices listed above",
  ]
}
export const Contact = {
  employer: 'How to contact the Alien',
  title: 'Email, IG DM, Crop circles',
  bullets: [
    "To grab my email, click the mail icon, this will copy my email address, you may now paste it into your AOL email account!",
    "DM me on Instagram, I beg of you, this is my prefered form of human contact. I love to see your lovely hams, Instagram lets me Picachu while we speak!",
    "Don't have instagram? I invite you to come check out the YouTube channel, I am always a few days behind, so for every day consistant 7 am content... it's me instagram",
    "Alien Tarot Readings are available in person, over the internet, or telepathically",
  ]
}
export const Birthday = {
  employer: 'Deep Dive',
  title: 'custom reading tailored to you',
  bullets: [
    "Want to blow your loved one's entire mind this year?",
    "Let's make it into an experiance of a life time by pausing the loop",
    "I show up in your life in person, or some loving family member contacts me and we gaslight you into thinking this is random 😈  ",
    "We look at the lessons from last year, check for termites, make a wish, and then get detailed instructions on how to ensure it comes true, NO FORTUNES 💃",
  ]
}
export const Holidalien = {
  employer: 'Alien Toronto Extraterrestrial Holiday Party for the People',
  title: '$333.33',
  bullets: [   "20 min interactive crowd performance ",
  " 90 min 1:1 alien readings for interested guests",
    "Full sparkling alien tarot action, with reversable sequin tentacles, amazing dance moves, high kicks, deep questions and cosmic comedy",
    "Book a 15 minute call so I may show your planning team how funny, charming and shiny I am!"
  ]
}
export const Standup = {
  employer: 'Alien Toronto Comedy',
  title: 'stage performance',
  bullets: [   "5 minute standup routine ",
  " Audience participation",
    "Full sparkling alien tarot action, with reversable sequin tentacles, amazing dance moves, high kicks, deep questions and cosmic comedy",
    "5 minute energetic Mimesynk that unlocks a core memory for the audience"
  ]
}